import React from "react";
import SlideUpOnScroll from "./slide-up";
import './page-title-2.css';

class PageTitle2Cols extends React.Component {


    render() {
        return (
            <div className={`page-title-2-cols flex-column-centered section ${this.props.className || ''}`} >

                <div className='page-title t2'>
                    <SlideUpOnScroll>{this.props.title}</SlideUpOnScroll>
                </div>

                <div className='page-subtitle-2 b1'>
                    <SlideUpOnScroll>
                        {this.props.subtitle}
                    </SlideUpOnScroll>
                </div>

            </div>
        );
    }
}

export default PageTitle2Cols;
